import { HopperIcon } from './ui/icons/HopperIcon';

// Shared with the live-camera rejected state. Both photo and manual fiscal
// duplicates must read as an already-used receipt, not a decoding failure.
export const RECEIPT_ALREADY_USED_TEXT = 'Этот чек уже был использован другим гостем.';

export function isReceiptAlreadyUsedCode(code: string): boolean {
  return code === 'already_used' || code === 'receipt_already_used';
}

export function ReceiptRejectionNotice({ message }: { message: string }) {
  return (
    <>
      <div className="scanner-error-icon"><HopperIcon name="error" size={36} /></div>
      <span className="scanner-kicker">Не получилось</span>
      <h2>Чек не удалось засчитать</h2>
      <p>{message}</p>
    </>
  );
}
